import { MakeEmbedWCCContentBlock } from 'components/content/mixins/embed';
import { DOMHelpers } from 'helpers/dom';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import { WCCContentBlock } from '../block/block';
import { WCCContentBlockConfig } from '../block/block.interfaces';

components.preload('fancybox-vimeo-new');

export interface WCCContentVimeoBlockConfig extends WCCContentBlockConfig {
    id: SubscribableOrNullableValue<string>
}

const ExtendedWCCContentBlock = [
    MakeEmbedWCCContentBlock()
].reduce((result, mixin) => mixin(result), WCCContentBlock);

export class WCCContentVimeoBlock extends ExtendedWCCContentBlock {
    id: Subscribable<string | undefined>

    constructor(config: WCCContentVimeoBlockConfig) {
        super(config);

        this.id = ko.flattenComputed(config.id);
    }

    protected override getNodes() {
        return DOMHelpers.createBindedNodes(`<fancybox-vimeo-new params="id: id"></fancybox-vimeo-new>`, { id: this.id });
    }
}